import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import seoReducer from "./slices/seoSlice";

const store = configureStore({
  reducer: {
    auth: authReducer,
    seo: seoReducer,
  },
});

export default store;
